export default "__VITE_ASSET__B2nH2u9W__"